import React, { useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    TextField,
    Button,
} from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const HumanInputModal = ({ open, question, onSubmit }) => {
    const [answer, setAnswer] = useState('');

    const handleSubmit = () => {
        onSubmit(answer);
        setAnswer('');
    };

    return (
        <Modal
            open={open}
            aria-labelledby="human-input-modal-title"
            aria-describedby="human-input-modal-description"
        >
            <Box sx={style}>
                <Typography id="human-input-modal-title" variant="h6" component="h2">
                    Input Required
                </Typography>
                <Typography id="human-input-modal-description" sx={{ mt: 2 }}>
                    {question}
                </Typography>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Your answer..."
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    sx={{ mt: 2 }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleSubmit();
                        }
                    }}
                />
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="contained" onClick={handleSubmit}>Submit</Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default HumanInputModal;


// import React, { useState, useEffect } from 'react';
// import {
//     Modal,
//     Box,
//     Typography,
//     TextField,
//     Button,
//     Stack,
//     IconButton,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';

// // Updated style for a more modern appearance
// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: '90%',
//     maxWidth: 450,
//     bgcolor: 'background.paper',
//     borderRadius: '8px', // Softer corners
//     boxShadow: 24,
//     p: 3,
// };

// /**
//  * A modal component to get user input.
//  * @param {boolean} open - Controls if the modal is visible.
//  * @param {function} onClose - Function to call when the modal is requested to be closed.
//  * @param {string} question - The question or prompt to display to the user.
//  * @param {function} onSubmit - Callback function that receives the user's answer.
//  */
// const HumanInputModal = ({ open, onClose, question, onSubmit }) => {
//     const [answer, setAnswer] = useState('');

//     // Clear the answer field whenever the modal opens
//     useEffect(() => {
//         if (open) {
//             setAnswer('');
//         }
//     }, [open]);

//     // Handle form submission
//     const handleFormSubmit = (event) => {
//         event.preventDefault(); // Prevent the default form submission (page reload)
//         if (answer.trim()) { // Ensure the answer is not empty
//             onSubmit(answer);
//         }
//     };

//     return (
//         <Modal
//             open={open}
//             onClose={onClose}
//             aria-labelledby="human-input-modal-title"
//             aria-describedby="human-input-modal-description"
//         >
//             {/* Using a form element for semantic HTML and native 'Enter' key submission */}
//             <Box component="form" onSubmit={handleFormSubmit} sx={style}>
//                 <Stack spacing={2}> {/* Use Stack for consistent vertical spacing */}
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                         <Typography id="human-input-modal-title" variant="h6" component="h2">
//                             Input Required
//                         </Typography>
//                         <IconButton aria-label="close" onClick={onClose} size="small">
//                             <CloseIcon />
//                         </IconButton>
//                     </Box>
                    
//                     <Typography id="human-input-modal-description">
//                         {question}
//                     </Typography>

//                     <TextField
//                         autoFocus // Automatically focus the input field for better UX
//                         fullWidth
//                         variant="outlined"
//                         label="Your answer" // Use a label for accessibility
//                         value={answer}
//                         onChange={(e) => setAnswer(e.target.value)}
//                     />

//                     <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1 }}>
//                         <Button type="submit" variant="contained">
//                             Submit
//                         </Button>
//                     </Box>
//                 </Stack>
//             </Box>
//         </Modal>
//     );
// };

// export default HumanInputModal;